export function renderFormattedTitle(title: string): string {
    return title ? title : '';
}